var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 126,
    viewBox: "0 0 141 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1429_1708)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1429_1708",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 141,
    height: 126,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 141,
    height: 126
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.099 11.1989C122.535 4.64984 113.612 1 104.336 1H36.001C16.6259 1 1 16.5635 1 35.7768V90.18C1 109.393 16.6951 124.957 36.001 124.957H104.336C123.642 124.957 139.344 109.393 139.344 90.18V35.7768C139.344 26.5489 135.671 17.7342 129.099 11.1989"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.099 11.1989C122.535 4.64984 113.612 1 104.336 1H36.001C16.6259 1 1 16.5635 1 35.7768V90.18C1 109.393 16.6951 124.957 36.001 124.957H104.336C123.642 124.957 139.344 109.393 139.344 90.18V35.7768C139.344 26.5489 135.671 17.7342 129.099 11.1989",
    fill: "#00B695",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.393 11.9068C128.784 12.2969 129.417 12.2961 129.807 11.9052C130.197 11.5142 130.197 10.881 129.806 10.491L128.393 11.9068ZM129.805 10.4898C129.413 10.1004 128.78 10.1021 128.39 10.4937C128.001 10.8853 128.003 11.5185 128.394 11.9079L129.805 10.4898ZM129.806 10.491C123.052 3.75277 113.874 0 104.336 0V2C113.35 2 122.018 5.54691 128.393 11.9068L129.806 10.491ZM104.336 0H36.001V2H104.336V0ZM36.001 0C16.079 0 0 16.0058 0 35.7768H2C2 17.1211 17.1729 2 36.001 2V0ZM0 35.7768V90.18H2V35.7768H0ZM0 90.18C0 109.952 16.1495 125.957 36.001 125.957V123.957C17.2407 123.957 2 108.834 2 90.18H0ZM36.001 125.957H104.336V123.957H36.001V125.957ZM104.336 125.957C124.187 125.957 140.344 109.952 140.344 90.18H138.344C138.344 108.834 123.096 123.957 104.336 123.957V125.957ZM140.344 90.18V35.7768H138.344V90.18H140.344ZM140.344 35.7768C140.344 26.2815 136.564 17.212 129.805 10.4898L128.394 11.9079C134.778 18.2563 138.344 26.8162 138.344 35.7768H140.344Z",
    fill: "url(#paint0_linear_1429_1708)",
    mask: "url(#path-1-outside-1_1429_1708)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_1429_1708)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1429_1708",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.895 45.4864L115.341 46.0373L84.138 70.8975C80.2713 73.9276 75.4915 75.5803 70.5872 75.5803C65.6691 75.5803 60.9723 73.9276 57.0987 70.8975L25.6254 46.4505L24.7193 45.5552C23.1352 43.4893 23.3428 40.5281 25.2104 38.6688C27.002 36.8094 29.9764 36.6028 32.1276 38.1867L63.255 62.9781C67.3292 66.2905 73.0774 66.2905 77.0894 62.9781L108.279 38.1867C109.323 37.2226 110.707 36.7337 112.16 36.8094C113.536 36.9471 114.857 37.5738 115.819 38.5999C117.548 40.597 117.548 43.4893 115.895 45.4864"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.895 45.4864L115.341 46.0373L84.138 70.8975C80.2713 73.9276 75.4915 75.5803 70.5872 75.5803C65.6691 75.5803 60.9723 73.9276 57.0987 70.8975L25.6254 46.4505L24.7193 45.5552C23.1352 43.4893 23.3428 40.5281 25.2104 38.6688C27.002 36.8094 29.9764 36.6028 32.1276 38.1867L63.255 62.9781C67.3292 66.2905 73.0774 66.2905 77.0894 62.9781L108.279 38.1867C109.323 37.2226 110.707 36.7337 112.16 36.8094C113.536 36.9471 114.857 37.5738 115.819 38.5999C117.548 40.597 117.548 43.4893 115.895 45.4864",
    fill: "url(#paint1_linear_1429_1708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.341 46.0373L115.466 46.1937L115.475 46.1868L115.483 46.179L115.341 46.0373ZM84.138 70.8975L84.2613 71.0549L84.2626 71.0539L84.138 70.8975ZM57.0987 70.8975L57.2219 70.74L57.2214 70.7396L57.0987 70.8975ZM25.6254 46.4505L25.4849 46.5928L25.4933 46.6011L25.5028 46.6084L25.6254 46.4505ZM24.7193 45.5552L24.5606 45.6769L24.5689 45.6879L24.5787 45.6975L24.7193 45.5552ZM25.2104 38.6688L25.3515 38.8105L25.3544 38.8075L25.2104 38.6688ZM32.1276 38.1867L32.2523 38.0301L32.2462 38.0256L32.1276 38.1867ZM63.255 62.9781L63.3811 62.8229L63.3796 62.8216L63.255 62.9781ZM77.0894 62.9781L76.9649 62.8215L76.962 62.8238L77.0894 62.9781ZM108.279 38.1867L108.403 38.3433L108.409 38.3387L108.415 38.3337L108.279 38.1867ZM112.16 36.8094L112.179 36.6102L112.17 36.6097L112.16 36.8094ZM115.819 38.5999L115.97 38.4689L115.965 38.4631L115.819 38.5999ZM115.754 45.3446L115.2 45.8956L115.483 46.179L116.036 45.6281L115.754 45.3446ZM115.217 45.8809L84.0133 70.7411L84.2626 71.0539L115.466 46.1937L115.217 45.8809ZM84.0146 70.7401C80.183 73.7426 75.4466 75.3803 70.5872 75.3803V75.7803C75.5363 75.7803 80.3595 74.1125 84.2613 71.0549L84.0146 70.7401ZM70.5872 75.3803C65.7147 75.3803 61.0611 73.7431 57.2219 70.74L56.9754 71.055C60.8835 74.112 65.6235 75.7803 70.5872 75.7803V75.3803ZM57.2214 70.7396L25.7481 46.2925L25.5028 46.6084L56.976 71.0555L57.2214 70.7396ZM25.766 46.3082L24.8598 45.413L24.5787 45.6975L25.4849 46.5928L25.766 46.3082ZM24.878 45.4336C23.356 43.4485 23.5541 40.6 25.3515 38.8105L25.0693 38.527C23.1315 40.4563 22.9145 43.5301 24.5606 45.6769L24.878 45.4336ZM25.3544 38.8075C27.0727 37.0242 29.9342 36.8201 32.009 38.3478L32.2462 38.0256C30.0185 36.3855 26.9312 36.5946 25.0664 38.53L25.3544 38.8075ZM32.003 38.3431L63.1304 63.1345L63.3796 62.8216L32.2522 38.0303L32.003 38.3431ZM63.1288 63.1332C67.276 66.5049 73.1302 66.5062 77.2167 63.1323L76.962 62.8238C73.0245 66.0747 67.3824 66.076 63.3811 62.8229L63.1288 63.1332ZM77.2138 63.1346L108.403 38.3433L108.155 38.0301L76.9649 62.8215L77.2138 63.1346ZM108.415 38.3337C109.418 37.4073 110.749 36.9361 112.149 37.0091L112.17 36.6097C110.665 36.5312 109.229 37.0379 108.143 38.0397L108.415 38.3337ZM112.14 37.0084C113.47 37.1415 114.746 37.7473 115.673 38.7366L115.965 38.4631C114.969 37.4003 113.602 36.7527 112.179 36.6104L112.14 37.0084ZM115.668 38.7308C117.332 40.6531 117.332 43.4362 115.741 45.3588L116.049 45.6139C117.764 43.5424 117.764 40.5408 115.97 38.469L115.668 38.7308Z",
    fill: "url(#paint2_linear_1429_1708)",
    fillOpacity: 0.5,
    mask: "url(#path-3-inside-2_1429_1708)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1429_1708",
    x: -15,
    y: -15,
    width: 170.344,
    height: 155.957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_1708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_1708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_1429_1708",
    x: 8.65723,
    y: 21.8018,
    width: 123.468,
    height: 68.7783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_1708"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.447059 0 0 0 0 0.368627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1429_1708",
    result: "effect2_dropShadow_1429_1708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1429_1708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_1708",
    x1: 23.0221,
    y1: 15.4411,
    x2: 99.8484,
    y2: 121.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_1708",
    x1: 110.499,
    y1: 43.8044,
    x2: 6.91296,
    y2: 51.9448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1429_1708",
    x1: 113.121,
    y1: 57.0113,
    x2: 22.9998,
    y2: 66.0605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailImg);
export default __webpack_public_path__ + "static/media/emailImg.47ba047635f6ea58e9cffd9114c8ee39.svg";
export { ForwardRef as ReactComponent };